import { Config } from '../../Config';

export function isFeatureDisabled(feature: string) {
  return Config.DISABLED_FUNCTIONALITY.includes(feature);
}

export const SideNav = 'SideNav';
